export class OperationError {
  title?: string;
  message: string;
  eventId?: any;
  errorCode?: number;
  isBusinessError?: boolean;
  isBuyOperation?: boolean;
  error: any;

  constructor(error: any, isBuy?: boolean) {
    this.error = this.parseJSON(error);
    this.message =
      error.ErrorMessage ??
      error.message ??
      'Se ha detectado un error. Por favor, intente de nuevo.';
    this.eventId = error.EventId ?? error.event_id;
    this.isBusinessError = error.IsBussinessError;
    this.title = error.title ?? '';
    this.isBuyOperation = isBuy;
    this.errorCode = error.ErrorCode;

    /**
     * Spead error is identified with 14 error code
     */
    if (this.errorCode === 14) {
      this.createSpreadError();
    }
  }

  toJSON() {
    return {
      error: this.error,
      title: this.title,
      message: this.message,
      eventId: this.eventId,
      errorCode: this.errorCode,
      isBuyOperation: this.isBuyOperation,
      isBusinessError: this.isBusinessError,
    };
  }

  parseJSON(value: any) {
    try {
      return JSON.stringify(value);
    } catch (e) {
      return '';
    }
  }

  private createSpreadError() {
    this.title = 'La orden supera el límite del Spread permitido';
    this.message = this.isBuyOperation
      ? `<span>El precio objetivo debe estar entre el 3% como máximo y 20% como mínimo, del valor del instrumento en el mercado.</span>
    <br><br><span>Es decir, si el precio es 100, lo más caro que puedes comprar es 103 y lo más barato 80.</span>`
      : `<span>El precio objetivo debe estar entre el 20% hacia arriba y el 3% por debajo del valor del instrumento en el mercado.</span>
    <br><br><span>Es decir, si el precio es 100, lo más caro que puedes vender es 120 y lo más barato 97.</span>`;
  }
}
